var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var loginState = {
    data: null,
    error: null,
    loading: false
};
var userInfoState = {
    data: null,
    error: null,
    loading: false
};
var loginReducer = function (state, action) {
    if (state === void 0) { state = loginState; }
    switch (action.type) {
        case Types.LOGIN_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.LOGIN_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.LOGIN_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.LOGIN_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var userInfoReducer = function (state, action) {
    if (state === void 0) { state = userInfoState; }
    switch (action.type) {
        case Types.GET_USER_INFO_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_USER_INFO_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_USER_INFO_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_USER_INFO_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var AuthenticationReducer = {
    loginData: loginReducer,
    userInfoData: userInfoReducer,
};
export var loginData = function (state) { return (state.loginData.data ? state.loginData.data : null); };
export var loginError = function (state) { return state.loginData.error; };
export var isLogging = function (state) { return state.loginData.loading; };
export var userInfoData = function (state) { return (state.userInfoData.data ? state.userInfoData.data : null); };
export var userInfoError = function (state) { return state.userInfoData.error; };
export var isLoadingUserInfo = function (state) { return state.userInfoData.loading; };
export default AuthenticationReducer;
